import type { Template } from "@/types";

export const PO_04_H2_V2: Template[] = [
    {
        id: "po-04-h2v2-01",
        name: "PO 01 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 13, y: 277, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 213, y: 277, width: 432, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 277, width: 432, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1094, y: 277, width: 192, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-02",
        name: "PO 02 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 113, y: 111, width: 423, height: 606, rotation: 0, imageRotation: 0 },
            { id: "2", x: 688, y: 111, width: 569, height: 335, rotation: 0, imageRotation: 0 },
            { id: "3", x: 688, y: 454, width: 185, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 881, y: 454, width: 376, height: 263, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-03",
        name: "PO 03 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 733, y: 155, width: 479, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 733, y: 447, width: 155, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 896, y: 447, width: 317, height: 226, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-04",
        name: "PO 04 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 40, y: 210, width: 284, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 332, y: 210, width: 283, height: 407, rotation: 0, imageRotation: 0 },
            { id: "3", x: 761, y: 139, width: 425, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 417, width: 425, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-05",
        name: "PO 05 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 13, y: 277, width: 432, height: 276, rotation: 0, imageRotation: 0 },            
            { id: "2", x: 453, y: 277, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 653, y: 277, width: 192, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 853, y: 277, width: 431, height: 276, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h2v2-06",
        name: "PO 06 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 87, y: 175, width: 743, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 838, y: 175, width: 372, height: 234, rotation: 0, imageRotation: 0 },
            { id: "3", x: 838, y: 417, width: 182, height: 234, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1028, y: 417, width: 182, height: 234, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-07",
        name: "PO 07 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 81, y: 157, width: 355, height: 512, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 444, y: 157, width: 410, height: 252, rotation: 0, imageRotation: 0 },
            { id: "3", x: 444, y: 417, width: 410, height: 252, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 157, width: 356, height: 513, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-08",
        name: "PO 08 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 80, y: 157, width: 356, height: 513, rotation: 0, imageRotation: 0 },
            { id: "2", x: 444, y: 157, width: 356, height: 513, rotation: 0, imageRotation: 0 },
            { id: "3", x: 808, y: 157, width: 411, height: 252, rotation: 0, imageRotation: 0 },
            { id: "4", x: 808, y: 417, width: 411, height: 252, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-09",
        name: "PO 09 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 272, y: 83, width: 516, height: 326, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 272, y: 417, width: 230, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 510, y: 417, width: 516, height: 326, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 83, width: 230, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h2v2-10",
        name: "PO 10 - H2V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h2_v2_10.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 63, y: 159, width: 385, height: 249, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 416, width: 189, height: 249, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 416, width: 188, height: 249, rotation: 0, imageRotation: 0 },
            { id: "4", x: 456, y: 159, width: 779, height: 506, rotation: 0, imageRotation: 0 }
        ],
    }
];